"use client";

import { Retailer } from "@/features/retailers/Retailer";
import { RetailerStoryblok } from "@/generated/sb/sb-types";
import { useState } from "react";
import { ISbStoryData } from "storyblok-js-client";
import styles from "./Retailers.module.css";

const containsSearchTerm = (
  retailer: ISbStoryData<RetailerStoryblok>,
  searchTerm: string,
) => {
  if (!searchTerm) return true;
  if (retailer?.content?.name?.toLowerCase().includes(searchTerm.toLowerCase()))
    return true;
  if (
    retailer?.content?.address?.toLowerCase().includes(searchTerm.toLowerCase())
  )
    return true;
  if (retailer?.content?.city?.toLowerCase().includes(searchTerm.toLowerCase()))
    return true;
  if (
    retailer?.content?.country?.toLowerCase().includes(searchTerm.toLowerCase())
  )
    return true;
  if (
    retailer?.content?.phone?.toLowerCase().includes(searchTerm.toLowerCase())
  )
    return true;

  return false;
};

export const Retailers = ({
  retailers,
}: {
  retailers: ISbStoryData<RetailerStoryblok>[];
}) => {
  const [searchTerm, _setSearchTerm] = useState("");

  const filteredRetailers = retailers.filter(retailer =>
    containsSearchTerm(retailer, searchTerm),
  );

  return (
    <div className={styles["client-wrapper"]}>
      {/*
<input
        placeholder="Search..."
        className={styles.input}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
  */}

      <div className={styles.container}>
        <table>
          <tr>
            <th>Store</th>
            <th>City</th>
            <th>Address</th>
            <th>Opening hours</th>
          </tr>
          {filteredRetailers.length > 0 ? (
            filteredRetailers.map(retailer => (
              <Retailer retailer={retailer.content} key={retailer.release_id} />
            ))
          ) : (
            <tr>
              <td>No retailers found</td>
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};
